import { useEffect, useState } from "react";

import {
	IonButton,
	IonButtons,
	IonCard,
	IonCardContent,
	IonCardHeader,
	IonCardSubtitle,
	IonCardTitle,
	IonContent,
	IonFooter,
	IonHeader,
	IonIcon,
	IonInput,
	IonItem,
	IonLabel,
	IonList,
	IonModal,
	IonPage,
	IonText,
	IonTitle,
	IonToolbar,
} from "@ionic/react";
import { arrowBackOutline, warning } from "ionicons/icons";
import { get, isEmpty, some } from "lodash";
import { getPartDetails, MetadataObject, queryMasterdata } from "../../api";
import { BarcodeScanner } from "../../components/barcode-scanner";
import useAuth from "../../context/auth.context";
import { UserPhoto } from "../../hooks";
import { useHistory } from "react-router";
import { catchError, EMPTY } from "rxjs";
import { useTranslation } from "react-i18next";
import { CAMERA_OVERLAY_STYLE } from '../../constants';

function BarcodePage() {
	const [availablePhotos, setAvailablePhotos] = useState<UserPhoto[]>([]);
	const [barcode, setBarcode] = useState<string>("");
	const [isOpen, setIsOpen] = useState<boolean>(true);
	const [masterData, setMasterData] = useState<MetadataObject>();
	const [masterDataError, setMasterDataError] = useState<string>();

	const history = useHistory();

	const { acquireToken } = useAuth();
	const { t } = useTranslation();

	useEffect(() => {
		return () => {
			setIsOpen(false);
		};
	}, []);

	function onBarcodeInput(event: any) {
		const text = event.target.value;
		if (isValidBarcode(text)) {
			setBarcode(text);
			onFoundResult(text);
		} else {
			setBarcode(text);
		}
	}

	function onFoundResult(text: string) {
		setMasterData(undefined);
		setIsOpen(false);
		setMasterDataError(undefined);

		history.push(`/details/${text}`);
	}

	function hasOcrPhoto() {
		return some(
			availablePhotos,
			(photo) => get(photo, "metadata.target", "") === "ocr"
		);
	}

	function submitBarcode() {
		if (isValidBarcode(barcode)) {
			history.push(`/details/${barcode}?newAlbum=true`);
		}
	}

	function onDismissModal() {
		setIsOpen(false);
	}

	function onScanNext() {
		setBarcode("");
		setIsOpen(true);
	}

	function isValidBarcode(code: string): boolean {
		return !isEmpty(code) && code.length === 8;
	}

	function onBack() {
		history.push("/landing");
	}

	return (
		<IonPage>
			<IonHeader>
				<IonToolbar>
					<IonButtons slot="start">
						{/* <IonBackButton defaultHref='/landing' /> */}
						<IonButton onClick={onBack} size="large">
							<IonIcon icon={arrowBackOutline} slot="icon-only" />
						</IonButton>
					</IonButtons>
					<IonTitle>{t("dataCollection.title")}</IonTitle>
				</IonToolbar>
			</IonHeader>
			<IonContent>
				<IonItem>{t("dataCollection.instructions")}</IonItem>
				<IonItem>
					<IonLabel>{t("dataCollection.barcodeLabel")}</IonLabel>
					<IonInput
						clearInput={true}
						onIonChange={onBarcodeInput}
						type="number"
						value={barcode}
					/>
				</IonItem>
				<IonCard>
					{isValidBarcode(barcode) && (
						<IonCardHeader>
							{masterDataError ? (
								<IonCardSubtitle color="warning">
									{masterDataError}
								</IonCardSubtitle>
							) : (
								<IonCardSubtitle>
									{masterData?.Description}
								</IonCardSubtitle>
							)}

							<IonCardContent>
								<IonList>
									{!hasOcrPhoto() && (
										<IonItem>
											<IonIcon
												color="warning"
												icon={warning}
												size="small"
											/>
											<IonText>
												{t(
													"dataCollection.noTextPhotoError"
												)}
											</IonText>
										</IonItem>
									)}
									<IonItem>
										<IonText>
											{`${availablePhotos.length} images found`}
										</IonText>
									</IonItem>
								</IonList>
								<IonButton
									color="primary"
									expand="block"
									onClick={submitBarcode}
								>
									{t("dataCollection.editPhotos")}
								</IonButton>
							</IonCardContent>
						</IonCardHeader>
					)}
				</IonCard>
				<IonModal
					isOpen={isOpen}
					onDidDismiss={() => setIsOpen(false)}
					style={CAMERA_OVERLAY_STYLE}
					>
					<BarcodeScanner
						onDismiss={onDismissModal}
						onFoundResult={setBarcode}
					/>
				</IonModal>
			</IonContent>
			<IonFooter>
				<IonToolbar>
					<IonButton
						color="primary"
						expand="block"
						onClick={onScanNext}
					>
						{t("dataCollection.scanNext")}
					</IonButton>
				</IonToolbar>
			</IonFooter>
		</IonPage>
	);
}

export default BarcodePage;
